import { MenuItem } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { ImportUsersFormValues, UpdateKeyListUsers } from "../importUsersTypes"

type SelectUpdateKeyDropdownProps = Readonly<{}>

export function SelectUpdateKeyDropdown({}: SelectUpdateKeyDropdownProps) {
    return (
        <LocalizedStrict id="data-import-csv-field-update-key" attrs={{ label: true }}>
            <FormikDropdown<ImportUsersFormValues> name="updateKey" label="Update key">
                {Object.values(UpdateKeyListUsers).map((item) => {
                    return (
                        <MenuItem key={item} value={item}>
                            <LocalizedEnum base="create-or-edit-company-id-cards-update-key-mode" enumValue={item}>
                                <> {item}</>
                            </LocalizedEnum>
                        </MenuItem>
                    )
                })}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
